import React from 'react';
import classNames from 'classnames';
import styles from './filters-button-element.module.scss';
import type { FC, ButtonHTMLAttributes } from 'react';
import { FixButton } from "@/elements-react/fix-button";
import { useTranslation } from "react-i18next";
import { Icon } from "@/elements-react/fix-icon";

export interface FiltersButtonElementProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  count?: number;
  onClick?: () => void;
}

export const FiltersButtonElement: FC<FiltersButtonElementProps> = ({
  active = false,
  count = 0,
  className,
  onClick,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <FixButton
      type={'button'}
      className={classNames(styles.root, { [styles.active]: active }, className)}
      onClick={onClick}
      size={'small'}
      variant={'default'}
      {...rest}
    >
        <Icon name="filter" className={styles.icon} />
      <span className={styles.label}>{t("7hdv7w32qbxo8477.filter", "Filter")}</span>
      {count > 0 && <span className={styles.count}>{count}</span>}
    </FixButton>
  );
};

export default FiltersButtonElement;
